export default {
  meta: {
    title: '话术库管理',
    parentPath: 'BOT配置',
    breadcrumbs: ['BOT配置', '话术库管理'],
  },
};
